/** Defaults for Cart Success Notification Bar (gift locked in toast) */

export interface CongratsDesign {
  /** Main line — campaign can override */
  title: string;
  /** Secondary line under title */
  subtitle: string;
  accentColor: string;
  backgroundColor: string;
  textColor: string;
  mutedColor: string;
  borderRadius: number;
  /** Auto-dismiss duration in ms */
  autoCloseMs: number;
  /** Show countdown border / ring that drains until close */
  showCloseProgress: boolean;
  /** Position on storefront */
  position: 'bottom' | 'top';
  fontFamily: string;
  /** Use live theme scheme on storefront when true */
  autoFitTheme: boolean;
  /** Scheme id from last Refresh — pinned for storefront Auto-fit */
  themeSchemeId: string | null;
  enabled: boolean;
}

export const DEFAULT_CONGRATS_DESIGN: CongratsDesign = {
  title: 'Gift Locked In 🎁',
  subtitle: 'Added to cart',
  accentColor: '#0D7A5F',
  backgroundColor: '#FFFFFF',
  textColor: '#1A1A1A',
  mutedColor: '#6D7175',
  borderRadius: 14,
  autoCloseMs: 4500,
  showCloseProgress: true,
  position: 'bottom',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  autoFitTheme: true,
  themeSchemeId: null,
  enabled: true,
};

export { toColorInputValue } from './popupDefaults';
